import type { FormEvent } from "react";
import { useObserver, useSubtree } from "subtree.js/react";
import { FormError, OnboardingLayout, PrimaryButton } from "../../components/onboarding/OnboardingLayout";
import { StoreProfileFields } from "../../components/StoreProfileFields";
import { OnboardingShopActions, OnboardingShopState } from "./onboarding-shop-model";

export function OnboardingShopPage() {
  const state = useSubtree(OnboardingShopState);
  const actions = useSubtree(OnboardingShopActions);
  const observer = useObserver();
  const storeId = observer.watch(state.storeId);
  const claimReview = observer.watch(state.claimReview);
  const hostsPage = observer.watch(state.hostsPage);
  const draft = observer.watch(state.draft);
  const errors = observer.watch(state.errors);
  const form = observer.watch(state.form);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    void actions.submit();
  };

  return (
    <OnboardingLayout
      step="shop"
      title={claimReview ? "Review your shop details" : "Name your card shop or business"}
      description={
        claimReview
          ? "Check the details we have for this shop. Make any corrections, then confirm to continue."
          : "Whether you run a shop or sell from a table at shows, this is the name customers see. Description, logo and website can be added in Settings later."
      }
      storeId={storeId ?? undefined}
      claimWalkthrough={claimReview}
      footer={
        <div className="flex justify-end">
          <PrimaryButton type="submit" form="onboarding-shop" disabled={form.busy}>
            {form.busy ? "Saving…" : claimReview ? "Confirm and continue" : "Continue"}
          </PrimaryButton>
        </div>
      }
    >
      <FormError message={form.error} />

      <form id="onboarding-shop" onSubmit={submit} className="flex flex-col gap-3.5">
        {claimReview ? (
          <StoreProfileFields
            variant="onboarding"
            draft={draft}
            errors={errors}
            requireDescription={hostsPage}
            descriptionHint="Confirm these details match your shop, or edit them to make corrections."
            onChange={actions.setField}
          />
        ) : (
          <div>
            <label htmlFor="name" className="mb-1.5 block text-xs font-medium text-white">
              Shop or business name
            </label>
            <input
              id="name"
              value={draft.name}
              onChange={(e) => actions.setField("name", e.target.value)}
              className="field"
              placeholder="Card Corner"
            />
            {errors.name && <p className="field-error">{errors.name}</p>}
          </div>
        )}
      </form>
    </OnboardingLayout>
  );
}
